<template>
  <el-dialog
    :model-value="visible"
    @close="$emit('close')"
    title="Создать нового клиента"
    width="400px"
    destroy-on-close
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="formRef"
      label-width="90px"
      status-icon
      label-position="right"
    >
      <el-form-item label="ФИО" prop="fio" required>
        <el-input
          v-model="form.fio"
          ref="fioInput"
          autocomplete="off"
          @blur="onFioBlur"
        />
      </el-form-item>
      <el-form-item label="Телефон" prop="phone" required>
        <PhoneInput v-model:phone="form.phone" ref="phoneInput" @is-complete="handlePhoneComplete" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="$emit('close')">Отмена</el-button>
      <el-button type="primary" @click="onSave">Создать</el-button>
    </template>
  </el-dialog>
</template>

<script>
import PhoneInput from '@/components/util/PhoneInput.vue'

export default {
  name: 'QuickClientCreate',
  components: { PhoneInput },
  props: {
    visible: Boolean,
    cityId: Number,
    defaultFio: { type: String, default: '' },
    defaultPhone: { type: String, default: '' }
  },
  data() {
    return {
      form: {
        fio: this.defaultFio || '',
        phone: this.defaultPhone || '',
      },
      isPhoneComplete: false,
      rules: {
        fio: [{ required: true, message: 'Укажите ФИО', trigger: 'blur' }],
        phone: [{ required: true, message: 'Введите телефон', trigger: 'blur' }]
      }
    }
  },
  watch: {
    defaultFio(val) { this.form.fio = this.formatFio(val) },
    defaultPhone(val) { this.form.phone = val },
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            // Всегда форматируем ФИО при открытии
            this.form.fio = this.formatFio(this.form.fio)
            const cleanedPhone = (this.form.phone || '').replace(/\D/g, '');
            // Если пользователь искал по имени или телефон неполный — фокус на ФИО
            if (this.form.fio && (!cleanedPhone || cleanedPhone.length < 11)) {
              if (this.$refs.fioInput?.focus) {
                this.$refs.fioInput.focus();
              }
            } else {
              if (this.$refs.phoneInput?.focus) {
                this.$refs.phoneInput.focus();
              }
            }
          }, 200);
        });
      }
    }
  },
  methods: {
    handlePhoneComplete(isComplete) {
      this.isPhoneComplete = isComplete
    },
    onSave() {
      if (!this.isPhoneComplete) {
        this.$message.error('Пожалуйста, введите полный номер телефона')
        return
      }
      this.$refs.formRef.validate(valid => {
        if (valid) {
          // Вернуть только нужное!
          this.$emit('save', {
            fio: this.form.fio,
            phone: this.form.phone
          })
        }
      })
    },
    formatFio(fio) {
      if (!fio) return '';
      return fio
        .split(' ')
        .filter(Boolean)
        .map(word => word[0] ? word[0].toUpperCase() + word.slice(1).toLowerCase() : '')
        .join(' ');
    },
    onFioBlur() {
      this.form.fio = this.formatFio(this.form.fio);
    }
  }
}
</script>
